<template>
  <div>
    <a-row type="flex">
      <a-col :xs="24">
        <h1>Joe's APIs</h1>
      </a-col>
    </a-row>
    <a-row type="flex" justify="space-around">
      <a-col :xs="20" class='text-left'>

        <p>
          I've made a few endpoints for anyone to use. There have been some great efforts by news organizations to compile solid data around the COVID-19 pandemic. In some cases the raw data is provided to the public but is not always in a form that best suits all needs. I've decided to fill a small gap and turn some of the data into APIs that web developers can use to display the data.
        </p>
        <p>
          The APIs are free to use but please check the attribution to make sure you cite the organization providing the data.
        </p>

        <h3>Try It Out</h3>
        <p>
          You can try sending sample requests in Postman. Click the button below to open Postman and Joe's APIs collection will be imported.
        </p>
        <a target="_blank" href='https://app.getpostman.com/run-collection/62879a11214ab6452cd9'><img src='https://run.pstmn.io/button.svg' /></a>

        <h3>Contact</h3>
        <p>
          Email: data@joeczubiak.com
        </p>
        <p>
          Please email me if you found this useful or are using the data on a public website. I would love to know!
        </p>
        <p>
          Suggestions for improvements or new endpoints and data sources are also welcome.
        </p>
      </a-col>
    </a-row>
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue';

export default {
  name: 'Home',
  components: {
    // HelloWorld,
  },
  metaInfo: {
    title: 'Joe\'s APIs | Free APIs For Developers | Joe Czubiak',
    meta: [
      { name: 'description', content: 'Joe\'s API service is providing free APIs for developers to use. We are serving JSON formatted coronavirus covid-19 data.' },
    ],
  },
};
</script>
<style scoped>
h3 {
  margin-top: 3em;
}

</style>
